"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "The same bib cannot not be entered twice in the same race.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "As the competitor has already paid for their new entry, you should cancel this entry");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "That entry must be removed before this one can be processed.");
class ExistingEntry extends _react.Component {
  render() {
    const newRace = this.props.newRace;
    return (
      /*#__PURE__*/
      // We know which race the paddler is changing to but the already have an
      // entry in that race.
      _react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, 'The competitor also has a ' + newRace.existingEntryStatusDescription + ' entry under their new bib number.'), _ref, newRace.hasPaidForExistingEntry ? _ref2 : _ref3)
    );
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ExistingEntry;